import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import classNames from 'classnames';

export const PrivateRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const { mode } = useSelector((state: RootState) => state.theme);

  // 如果正在加载认证状态，显示加载指示器
  if (isLoading || isAuthenticated === null) {
    return (
      <div className={classNames('flex justify-center items-center h-screen', {
        'bg-white': mode === 'light',
        'bg-gray-900': mode === 'dark'
      })}>
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  // 如果未认证，重定向到登录页面
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 如果已认证，渲染子路由
  return <Outlet />;
}; 